import Backbone from 'backbone';

export default Backbone.Model.extend({
    url: '/web-gateway/snapshot/usageIndicators',
    backend: 'gcapi',
    hasIndicator: function(indicatorType, indicatorKey) {
        if (indicatorType === 'device') {
            return this.get('deviceBasedIndicators')[indicatorKey];
        } else if (indicatorType === 'activity') {
            var lastActivityOfType = this.get('performanceBasedIndicators').activityIndicators[indicatorKey];

            return lastActivityOfType && lastActivityOfType.lastActivityDate !== null;
        } else if (indicatorType === 'wellness') {
            return this.get('performanceBasedIndicators').wellnessIndicators[indicatorKey];
        } else if (indicatorType === 'sleep') {
            return this.get('sleepBasedIndicators')[indicatorType];
        }
    },

    hasHistoricalIndicator: function(indicatorType, indicatorKey) {
        if (indicatorType === 'device') {
            return this.get('historicalDeviceBasedIndicators')[indicatorKey];
        }
        return false;
    },

    hasCurrentOrHistoricalIndicator: function(indicatorType, indicatorKey) {
        if (indicatorType === 'device') {
            return (
                (this.get('deviceBasedIndicators') && this.get('deviceBasedIndicators')[indicatorKey]) ||
                (this.get('historicalDeviceBasedIndicators') &&
                    this.get('historicalDeviceBasedIndicators')[indicatorKey])
            );
        }
        return false;
    },

    checkDeviceIndicator: function(indicator) {
        var indicators = this.get('deviceBasedIndicators');
        return indicators && indicators[indicator];
    }
});
